import classnames from "classnames";
import TireSeasonIcon from "component/design-system/badge/TireSeasonIcon";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import { useTranslation } from "next-i18next";
import { camelCaseToTitleCase } from "util/helper/helper";
import NbcFilterImage from "./NbcFilterImage";
import styles from "./tireProduct-extended-definition.style.module.scss";

const DISPLAY_ORDERS = [
  "speedRating", "loadIndex", "season", "widthInMm",
  "size", "offset", "surfaceFinish", "weight", "series", "model",
];

function sortOrder(a: any, b: any) {
  if (DISPLAY_ORDERS.indexOf(a) === -1 && DISPLAY_ORDERS.indexOf(b) === -1) {
    return 0; // If either a or b is not in DISPLAY_ORDERS, do not sort them
  }
  if (DISPLAY_ORDERS.indexOf(a) === -1) {
    return 1;
  }
  if (DISPLAY_ORDERS.indexOf(b) === -1) {
    return -1;
  }
  return DISPLAY_ORDERS.indexOf(a) - DISPLAY_ORDERS.indexOf(b);
}

function ExtendedDescription(props: any) {
  const {
    extendedDescription, gridView = false, season, extendedInfoKeys = [], maxKeys, filterableAttributes, iconSize = 20,
  } = props;

  const extendedInfo = { ...extendedDescription };
  const { t } = useTranslation("category");

  // const renderInfo = Object.keys(extendedInfo)
  //   .filter((_) => (extendedInfoKeys.length > 0 ? extendedInfoKeys.includes(_) : true) && extendedInfo[_])
  //   .sort(sortOrder)
  //   .map((info) => ({
  //     label: t(UI_LABEL[info]) || camelCaseToTitleCase(info),
  //     value: UI_VALUE[info] ? cloneElement(UI_VALUE[info], { ...extendedInfo }) : extendedInfo[info],
  //     hasInfo: needPopOver(info),
  //     headerText: ["speedRating", "loadIndex"].includes(info) ? extendedInfo[info] : "",
  //   }));

  // if (renderInfo.length === 0) {
  //   return null;
  // }

  if (!filterableAttributes) {
    return null;
  }

  return (
    <div className={styles.container}>

      <div className={classnames(styles.wheel_tire_accordion, { [styles.wheel_tire_grid]: gridView })}>
        {Object.keys(filterableAttributes).map((filterKey) => {
          const filterableValue = filterableAttributes[filterKey];
          if (Array.isArray(filterableValue) || !filterableValue) {
            return null;
          }

          return (
            <div
              key={filterKey}
              className={classnames("d-flex align-items-center justify-content-between p-t-20", styles.filterable_attribute_container, { [styles.wheel_tire_grid]: gridView })}
            >
              <div>
                <WheelTireSpec
                  label={camelCaseToTitleCase(filterKey)}
                  value={filterableValue}
                  gridView={gridView}
                />
              </div>
              {filterKey === "season" ? (
                <TireSeasonIcon
                  season={season}
                  width={iconSize}
                  height={iconSize}
                  fontSize={FONT_SIZE[0]}
                  iconOnly
                />
              ) : (
                <NbcFilterImage filterKey={filterKey} filterValue={filterableValue} size={iconSize} />
              )}
            </div>
          );
        })}
      </div>

      {/* <HideIf show={season}>
        <div className={classnames("d-flex align-items-center", { [styles.wheel_tire_grid]: gridView })}>
          <div className="m-r-10">
            <WheelTireSpec
              label={t("Type")}
              value={t(capitalize(season))}
              gridView={gridView}
            />
          </div>

          <TireSeasonIcon
            season={season}
            width={20}
            height={20}
            fontSize={FONT_SIZE[0]}
            iconOnly
          />
        </div>
      </HideIf> */}
    </div>
  );
}

function WheelTireSpec({ label, value, gridView }: { label: string, value: string, gridView: boolean }) {
  return (
    <div className={styles.eachSpec}>
      <div>
        <PAText className={`m-b-5 ${styles.label}`} component={gridView ? "span" : "p"} fontSize={FONT_SIZE[0]}>
          {label}
        </PAText>
        <PAText className={styles.value}>{value}</PAText>
      </div>
    </div>
  );
}
export default ExtendedDescription;
